












































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { MedTransGoConstants } from '../../util/constants';
import { ServiceType } from '../../types/request';
import { required } from 'vuelidate/lib/validators';
import { ObjectFactory } from '@/config/objectFactory';
import { MapUtils } from '@/util/mapUtils';
import MessageBox from '../../components/MessageBox.vue';
declare var google: any;
@Component({
    props: {
        serviceRequest: Object,
    },
    components: {
        MessageBox,
    },
    validations() {
        const validations = {
            serviceRequest: {
                roundTrip: {
                    required,
                },
                service: {
                    additionalService: {
                        required,
                    },
                    type: {
                        required,
                    },
                    selectedType: {
                        required,
                    },
                },
                transportation: {
                    visitType: {
                        required,
                    },
                    homeAssistance: {
                        required,
                    },
                },
                homeAssistance: {
                    address: {
                        fullAddress: {
                            required,
                        },
                        state: {
                            required,
                        },
                        city: {
                            required,
                        },
                        zip: {
                            required,
                        },
                    },
                    appointmentDate: {
                        required,
                    },
                    appointmentTime: {
                        required,
                    },
                },
                interpretation: {
                    isImmediateInterpretation: {
                        required,
                    },
                },
                telemedicine: {
                    interpreterRequired: {
                        required,
                    },
                },
            },
        };
        if (this.$props.serviceRequest.service.type !== 'Telemedicine') {
            delete validations.serviceRequest.telemedicine.interpreterRequired;
        }
        if (this.$props.serviceRequest.service.type === 'Telemedicine' || this.$props.serviceRequest.service.type === 'Delivery') {
            delete validations.serviceRequest.service.additionalService;
        }
        if (this.$props.serviceRequest.service.type !== 'Transportation' && this.$props.serviceRequest.service.type !== 'TransInterpreter') {
            delete validations.serviceRequest.transportation.visitType;
        }
        if (this.$props.serviceRequest.service.type !== 'Interpretation' && this.$props.serviceRequest.service.type !== 'TransInterpreter') {
            delete validations.serviceRequest.interpretation.isImmediateInterpretation;
        }
        if (this.$props.serviceRequest.service.type !== 'Transportation') {
            delete validations.serviceRequest.homeAssistance;
            delete validations.serviceRequest.transportation.homeAssistance;
            delete validations.serviceRequest.roundTrip;
        }
        if (this.$props.serviceRequest.transportation.homeAssistance === false &&
            validations.serviceRequest.homeAssistance) {
            delete validations.serviceRequest.homeAssistance;
        }
        if (this.$props.serviceRequest.sameAsTransportAddress === true &&
            validations.serviceRequest.homeAssistance) {
            delete validations.serviceRequest.homeAssistance.address;
        }
        if (this.$props.serviceRequest.followTransportRequest === true &&
            validations.serviceRequest.homeAssistance) {
            delete validations.serviceRequest.homeAssistance.appointmentDate;
            delete validations.serviceRequest.homeAssistance.appointmentTime;
        }
        return validations;
    },
})
export default class ServiceVisit extends Vue {

    private isEstimatedTimeValid = true;
    private inValidHours = false;
    private inValidMinutes = false;
    private isFormValid = false;
    private inValidHomeAssistanceHours = false;
    private inValidHomeAssistanceMinutes = false;
    private homeAssistanceGoogleAddress: any;
    private member = ObjectFactory.getCacheService().getMemberInfo();
    private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();

    public mounted() {
        this.validateForm();
        if (this.sessionInfo.scopes.includes('member')) {
            this.getMemberRequestCount();
        }
    }
    private setHomeAssistanceGoogleAddress() {
        setTimeout(() => {
            const element = document.getElementById('homeAssistanceAddress');
            this.homeAssistanceGoogleAddress = new google.maps.places.Autocomplete(element,
                { types: ['geocode'] });
            this.homeAssistanceGoogleAddress.addListener('place_changed', () => {
                this.$props.serviceRequest.homeAssistance.address =
                    MapUtils.parseGoogleAddress(this.homeAssistanceGoogleAddress);
            });
        });
    }

    private async getMemberRequestCount() {
        if (this.member.memberType && this.member.memberType === 'ORG_CUSTOMER') {
            const response = await ObjectFactory.getMemberService().
                getMemberRequestCount(this.$store.state.serverUrl);
            if (response.data) {
                if (response.data && this.member.maximumAllowedSubmission &&
                    response.data.requestCount >= this.member.maximumAllowedSubmission) {
                    const messageBox: any = this.$refs.messageBox;
                    messageBox.showModal();
                }
            }
        }
    }

    private backToHomePage() {
        this.$router.push({ path: `/requests` });
    }

    private setServiceType(type: ServiceType, additionalService?: boolean) {
        this.$props.serviceRequest.service.type = type;
        if (type !== 'TransInterpreter') {
            this.$props.serviceRequest.service.selectedType = type;
        }
        this.$props.serviceRequest.service.additionalService = additionalService;
        this.resetStops();
        this.validateForm();
        if (type === 'Transportation') {
            ObjectFactory.getOrganizationService()
                .getPreferredProviders(this.$store.state.serverUrl).then((response) => {
                    this.$store.commit('SET_PREFERRED_PROVIDER', response.data);
                });
        }
    }

    private setVisitType(type: string) {
        this.$props.serviceRequest.transportation.visitType = type;
    }

    private resetStops() {
        this.$props.serviceRequest.stops.isStop2Valid = false;
        this.$props.serviceRequest.stops.isStop3Valid = false;
        this.$props.serviceRequest.stops.isStop4Valid = false;
    }

    private validateForm() {
        const transportation = this.$props.serviceRequest.transportation;
        const service = this.$props.serviceRequest.service.type as ServiceType;
        if ((service === 'Transportation' || service === 'TransInterpreter')
            && (!transportation.estimatedVisitTime.hours || transportation.estimatedVisitTime.hours <= 0) &&
            (!transportation.estimatedVisitTime.minutes || transportation.estimatedVisitTime.minutes <= 0)) {
            this.isEstimatedTimeValid = false;
            this.isFormValid = false;
        } else {
            this.isEstimatedTimeValid = true;
            this.isFormValid = true;
        }
    }
    private validateVisitTime() {
        const transportation = this.$props.serviceRequest.transportation;
        const service = this.$props.serviceRequest.service.type as ServiceType;
        const hours = parseInt(transportation.estimatedVisitTime.hours, 10);
        const minutes = parseInt(transportation.estimatedVisitTime.minutes, 10);
        if (hours < 0 || hours > 23 || isNaN(hours)) {
            this.inValidHours = true;
            this.isFormValid = false;
        } else {
            this.inValidHours = false;
            this.isFormValid = true;
        }
        if (minutes < 0 || minutes > 59 || isNaN(minutes)) {
            this.inValidMinutes = true;
            this.isFormValid = false;
        } else {
            this.inValidMinutes = false;
            this.isFormValid = true;
        }
    }

    private validateHomeAssitanceEstimateTime() {
        const homeAssistance = this.$props.serviceRequest.homeAssistance;
        const hours = parseInt(homeAssistance.estimatedVisitTime.hours, 10);
        const minutes = parseInt(homeAssistance.estimatedVisitTime.minutes, 10);
        if (hours < 0 || hours > 23 || isNaN(hours)) {
            this.inValidHomeAssistanceHours = true;
            this.isFormValid = false;
        } else {
            this.inValidHomeAssistanceHours = false;
            this.isFormValid = true;
        }
        if (minutes < 0 || minutes > 59 || isNaN(minutes)) {
            this.inValidHomeAssistanceMinutes = true;
            this.isFormValid = false;
        } else {
            this.inValidHomeAssistanceMinutes = false;
            this.isFormValid = true;
        }
    }
    private validateHomeAssistanceTime() {
        const serviceRequest = this.$props.serviceRequest;
        if (serviceRequest.homeAssistance) {
            let time = new Array();
            time = serviceRequest.homeAssistance.appointmentTime.split(':');
            const hours = parseInt(time[0], 10);
            const minutes = parseInt(time[1], 10);
            if (isNaN(hours) || 0 > hours || hours >= 24 || isNaN(minutes) || 0 > minutes || minutes >= 60) {
                serviceRequest.homeAssistance.appointmentTime.time = '';
            }
        }
    }
    private nextStep() {
        this.$props.serviceRequest.stops.isStop1Valid = true;
        const service = this.$props.serviceRequest.service.type as ServiceType;
        if (service === 'Telemedicine') {
            this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_MEETING_DETAILS });
        } else if (service === 'Delivery') {
            this.$props.serviceRequest.stops.isStop2Valid = true;
            this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_PICKUP_DETAILS });
        } else {
            this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_VEHICLE_LANGUAGE });
        }
    }
}
